export const PHONE_DIGITS = 10;
export const MIN_PHONE_DIGITS = PHONE_DIGITS;
export const MAX_PHONE_DIGITS = PHONE_DIGITS;

/** Format up to 10 digits with spacing — any starting digit. */
export function formatPhone(value) {
  const digits = String(value || "").replace(/\D/g, "").slice(0, PHONE_DIGITS);
  if (!digits) return "";
  if (digits.length <= 4) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
  return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
}

/** @deprecated use formatPhone */
export const formatAuMobile = formatPhone;
/** @deprecated use formatPhone */
export const formatPhoneLoose = formatPhone;

/** Digits only; empty allowed unless required; exactly 10 digits when provided. */
export function isValidPhone(value, { required = false } = {}) {
  const digits = String(value || "").replace(/\D/g, "");
  if (!digits) return !required;
  return digits.length === PHONE_DIGITS;
}

/** @deprecated use isValidPhone */
export const isValidAuMobile = isValidPhone;
/** @deprecated use isValidPhone */
export const isValidOptionalPhone = (value) => isValidPhone(value);

export const PHONE_FIELD_NAMES = new Set(["phone", "secondary_phone"]);

export function formatPhoneFields(values, fields = PHONE_FIELD_NAMES) {
  const next = { ...values };
  fields.forEach((name) => {
    if (name in next) next[name] = formatPhone(next[name]);
  });
  return next;
}
